import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import WorkCard from '../components/WorkCard';
import { workItems } from '../data/services';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../components/ui/dialog';

const Work = () => {
  const [selectedWork, setSelectedWork] = useState(null);

  return (
    <main data-testid="work-page" className="pt-24 md:pt-32">
      {/* Hero */}
      <section className="container-wide pb-16 md:pb-24">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="eyebrow mb-6 block"
        >
          Work
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="text-huge font-['DM_Sans'] max-w-4xl mb-6"
        >
          Selected projects
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-lg md:text-xl text-muted-foreground max-w-2xl"
        >
          Browse our portfolio of signage and printing work across various categories.
        </motion.p>
      </section>

      {/* Coming Soon Notice */}
      <section className="container-wide pb-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="inline-flex items-center gap-2 px-4 py-2 bg-accent/20 rounded-full"
        >
          <span className="w-2 h-2 rounded-full bg-accent animate-pulse" />
          <span className="text-sm font-medium">Portfolio coming soon</span>
        </motion.div>
      </section>

      {/* Work Grid */}
      <section className="container-wide py-8 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
          {workItems.map((item, index) => (
            <WorkCard
              key={item.id}
              item={item}
              index={index}
              onClick={setSelectedWork}
            />
          ))}
        </div>
      </section>

      {/* Work Modal */}
      <Dialog open={!!selectedWork} onOpenChange={() => setSelectedWork(null)}>
        <DialogContent 
          data-testid="work-modal"
          className="sm:max-w-md"
        >
          <DialogHeader>
            <DialogTitle className="text-2xl font-['DM_Sans']">
              {selectedWork?.title}
            </DialogTitle>
            <DialogDescription className="sr-only">
              Project details for {selectedWork?.title}
            </DialogDescription>
          </DialogHeader>
          
          <div className="py-8">
            {/* Placeholder visual */}
            <div className="aspect-video bg-secondary grid-pattern mb-6 rounded" />
            
            <div className="space-y-4">
              <span className="pill-tag">{selectedWork?.category}</span>
              
              <p className="text-muted-foreground">
                Project photos available on request.
              </p>
              
              <p className="text-sm text-muted-foreground/70">
                Contact us for detailed project documentation and reference images.
              </p>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </main>
  );
};

export default Work;
